// extracted by mini-css-extract-plugin
export default {"tabContainer":"tabContainer-n6fPL","tabs":"tabs-gBeX5","tabName":"tabName-lCDJr","active":"active-Hzm7D"};